var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        width: _vm.width || "520px",
        title: _vm.title || _vm.$t("warning"),
        type: "question",
        persistent: "",
        "cancel-text": _vm.cancel || _vm.$t("cancel"),
        "confirm-text": _vm.confirm || _vm.$t("quit"),
        "hide-cta": _vm.hideCta,
        "show-close-button": _vm.showCloseButton,
        "content-class": _vm.contentClass,
      },
      on: { cancel: _vm.handleCancel, confirm: _vm.handleSubmit },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("v-card", { staticClass: "py-2 px-4 mb-2", attrs: { flat: "" } }, [
        _c("span", [
          _vm._v(
            " " + _vm._s(_vm.body || _vm.$t("unsaved-changes-warning")) + " "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }